import { difference, values } from 'lodash-es';

export enum UserRole {
  SuperAdmin = 'super-admin',
  Admin = 'admin',
  FieldManager = 'field-manager',
  ProjectManager = 'project-manager',
  Partner = 'partner',
  Candidate = 'candidate',
  TechnicalUser = 'technical-user',
  Contact = 'contact',
  UnAuthorized = 'unAuthorized',
}

export const getAllRoles: UserRole[] = values(UserRole);

export function getAllRolesExcept(userRoles: UserRole[]): UserRole[] {
  return difference(getAllRoles, userRoles);
}
